module.exports = __webpack_public_path__ + "static/gufs_right_section_fr@2x-872f5fc4c30bf57a8b4830eb48ef8405.png";